import { effects, registerEventHandler } from 'reffects';
import { globals } from 'reffects-batteries';
import { state } from 'reffects-store';
import { registerHttpCacheEvents } from 'events/cache';

function parsePayload(payload) {
  if (typeof payload === 'string') {
    return { configName: payload };
  }
  return payload;
}

export default function registerConfigEvents() {
  const cacheEvents = registerHttpCacheEvents(
    'CONFIG',
    function composeConfigCacheKeyFromPayload(payload) {
      return `config:${payload.configName}`;
    },
    function httpGetEffectFromPayload(payload) {
      const {
        source: { country, vertical, id },
        configName,
      } = payload;
      return {
        url: `/index.php/api/configs/${configName}/check?source=${country}_${vertical}_${id}`,
      };
    },
    function parseConfigFromHttpResponse(response) {
      return response;
    },
    function handleRetrievedConfig(config, payload) {
      return state.set({
        [`configs.${payload.configName}`]: config,
      });
    },
    { ttl: 1800 * 1000 } // store in cache for 30m
  );

  registerEventHandler(
    'LOAD_CONFIG',
    function loadConfig(
      {
        globals: {
          trovitData: {
            source: { countryId: country, verticalId: vertical, sourceId: id },
          },
        },
      },
      payload
    ) {
      const { configName } = parsePayload(payload);
      const source = { country, vertical, id };

      return effects.dispatch(cacheEvents.retrieve, { configName, source });
    },
    [globals.get('trovitData')]
  );
}
